import React, { useContext, useMemo, useState } from "react";
import { FetchBoundary } from "../../common/FetchBoundary";
import { PurchaseValidationContext } from "../PurchaseValidationContext";
import { useFetch } from "../../Hooks/useFetch";
import { AccountPharmaciesTabRow } from "./AccountPharmaciesTabRow";
import { Search } from "@material-ui/icons";
import { UnassignedWarningPanel } from "./UnassignedWarningPanel";
import { InputAdornment, TextField } from "@mui/material";
import MixpanelService from "../../utils/MixpanelService";

export const AccountPharmaciesTab = () => {
  const { accounts, coveredEntity340bId, accountModal, identifierMappingPath } =
    useContext(PurchaseValidationContext);

  const accountId = accountModal?.accountId;

  const account = accounts.find((acc) => acc.id === accountId) ?? {};
  const pharmaciesFetcher = useFetch(
    `/api/covered_entities/${account.id_340b}/accounts/${account.id}/pharmacies`
  );
  const pharmacies = pharmaciesFetcher.data?.pharmacies ?? [];

  const [searchInput, setSearchInput] = useState("");

  const filteredPharmacies = useMemo(
    () =>
      pharmacies
        .filter((p) => {
          if (searchInput.trim() === "") {
            return true;
          }

          if (p.name.toLowerCase().includes(searchInput.toLowerCase())) {
            return true;
          }

          return p.identifier_associations.find((ia) =>
            ia.identifier.toLowerCase().includes(searchInput.toLowerCase())
          );
        })
        .sort((a, b) => a.name.localeCompare(b.name)),
    [searchInput, pharmacies]
  );

  return (
    <div className="p-4">
      {account.account_type == "unassigned" ? <UnassignedWarningPanel /> : null}

      <div className="flex mb-4 justify-content-between align-items-center">
        <TextField
          label=""
          value={searchInput}
          onChange={(e) => {
            MixpanelService.track("esp_horizon_ad_search_accessed");
            setSearchInput(e.target.value);
          }}
          onBlur={() => MixpanelService.track("esp_horizon_ad_search_exited")}
          placeholder="Search for a Pharmacy or Identifier"
          size="small"
          style={{ width: 320 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <a
          href={`${identifierMappingPath}?id_340b=${coveredEntity340bId}&pharmacy_group=${account.group_name}`}
          rel="noopener noreferrer"
        >
          <button className="button button--blue">Manage Identifier Mappings</button>
        </a>
      </div>

      <div className="t--500 my-3">Pharmacies</div>

      <FetchBoundary {...pharmaciesFetcher}>
        <div className="t--left t--sm row-border-rounded container-fluid">
          <div className="row align-items-center py-3 bg--neutrals-gray-3 border--rounded-top">
            <div className="col t--500">Name</div>
            <div className="col t--500">Associated Identifiers</div>
          </div>
          {filteredPharmacies.map((pharmacy) => (
            <AccountPharmaciesTabRow key={pharmacy.name + pharmacy.address} pharmacy={pharmacy} />
          ))}
        </div>
      </FetchBoundary>
    </div>
  );
};
